import { IAutomationObject } from '../../types'


export const schema = 'AutomationApps.Functions.Schedules.Scheduler';


export interface IScheduler extends IAutomationObject {
    weekleySchedule: string,
    exeptionSchedule: string,
    currentStateText: string | undefined,
    value: any,
    dateFrom: Date,
    dateTo: Date,
    dataType: string,
    isOn: boolean,
    stateTextList: string | undefined,
    defaultValue: any | undefined,
    uTCOffset: number,
    isDaylightsSaving: boolean,
    timeZone: string
}




export const ViewModes = {
    listWeek: 'listWeek',
    timeGridWeek: 'timeGridWeek',
    exceptions: 'exceptions'
  }